import React from "react";
import "./NewNoteCreator.css";

import FinishNewNote from "./FinishNewNote/FinishNewNote";
import DiscardNewNote from "./DiscardNewNote/DiscardNewNote";



function NewNoteCreator(props: {noteStatus: string, finishNewNoteCallback: () => void, discardNewNoteCallback: () => void}): JSX.Element {
    const inputRef = React.useRef<HTMLInputElement>(null);
    const isNewNoteBeingOpened = props.noteStatus === "OpeningNewNote";

    React.useEffect(() => {
        if (isNewNoteBeingOpened) {
            inputRef.current?.focus();
        }
    }, [isNewNoteBeingOpened])

    let newNoteCreatorClassName: string;

    props.noteStatus === "OpeningNewNote" ? newNoteCreatorClassName = "openingNewNoteCreator" : 
    props.noteStatus === "ClosingNewNote" ? newNoteCreatorClassName = "closingNewNoteCreator" : newNoteCreatorClassName = "neutralNewNoteCreator";

    return (
        <section className={newNoteCreatorClassName}>
            <div className="noteTitle">
                <input type="text" className="noteTitleInput" placeholder="Title.." ref={inputRef}/>
            </div>

            <div className="noteText">
                <textarea className="noteTextInput" placeholder="Note.."></textarea>
            </div>

            <div className="buttons">
                <FinishNewNote callback={props.finishNewNoteCallback}/>
                <DiscardNewNote callback={props.discardNewNoteCallback}/>
            </div>
        </section>  
    )   
}

export default NewNoteCreator;
